import { createBrowserRouter } from "react-router-dom";
import DefaultLayout from "../layouts/default.layout";
import Home from "../../pages/users/home/home.page";
import RateFee from "../../pages/admin/rateFee/rateFee";
import UserLayout from "../layouts/user.layout";
import Profile from "../../pages/users/profile/profile.page";
import MacquarieRates from "../../pages/admin/macquarieRates/macquarieRates";
import ActivityLogs from "../../pages/admin/activityLogs/activityLogs";

export const router = createBrowserRouter([
    {
      path: "",
      element: <DefaultLayout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
      ],
    },
    {
      path: "",
      element: <UserLayout />,
      children: [
        {
          path: "/profile",
          element: <Profile />,
        },
        {
          path: "/rateFee",
          element: <RateFee />,
        },
        {
          path: "/macquarieRates",
          element: <MacquarieRates />,
        },
        {
          path: "/activity-logs",
          element: <ActivityLogs />,
        },
      ],
    },
  ]);
  